﻿import { Patient } from './patient';
import { Aidant } from './aidant';

export class AidantRelation {
    patient: Patient;
    aidant: Aidant;
    key: string;
    tempName: string;
}
